const scriptUtils = {
    loadScript(src, id = '') {
        return new Promise((resolve, reject) => {
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.id = id;
            script.type = 'text/javascript';
            script.onload = () => resolve(true);
            script.onerror = () => {
                const error = new Error(`loading script ${src}`);
                console.error(error);
                reject(error);
            };
            script.src = src;
            head.appendChild(script);
        });
    },
};

export default scriptUtils;
